// 05–07 — phase two/three stubs. Present in the markup as dashed-border stubs
// so v1 is not thrown away; hidden by the phase flag (README).
import { Section, SectionHead } from './primitives';

export function PhaseStub({
  label,
  numeral,
  title,
  body,
}: {
  label: string;
  numeral: string;
  title: string;
  body: string;
}) {
  return (
    <Section label={label}>
      <SectionHead numeral={numeral} title={title} />
      <div
        style={{
          background: 'var(--deeper)',
          border: '1px dashed rgba(127,227,232,0.4)',
          borderRadius: 12,
          padding: 20,
          fontSize: 18,
          color: 'var(--cyan-soft)',
        }}
      >
        {body}
      </div>
    </Section>
  );
}
